// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__25b6D","row":"ProcedureTreatmentSummary_row__17BoH"};